/**
 * Type guard to check if values is CurrentDateFilterValues.
 * @param values - The filter values to check.
 * @returns True if values is CurrentDateFilterValues.
 */
const isDateFilterValues = (values) => typeof values === "object" &&
    values !== null &&
    "type" in values &&
    values.type === "date";
/**
 * Type guard to check if values is CurrentNumberRangeFilterValues.
 * @param values - The filter values to check.
 * @returns True if values is CurrentNumberRangeFilterValues.
 */
const isNumberRangeFilterValues = (values) => typeof values === "object" &&
    values !== null &&
    "type" in values &&
    values.type === "number-range" &&
    "lowerLimit" in values &&
    "upperLimit" in values;
export const setCurrentFilterValuesReducer = (state, action) => {
    if (!state.currentFilterValues) {
        state.currentFilterValues = {};
    }
    for (const payload of action.payload) {
        const { filter, values } = payload;
        if (state.currentFilterValues &&
            ((Array.isArray(values) && values.length !== 0) ||
                isDateFilterValues(values) ||
                isNumberRangeFilterValues(values))) {
            state.currentFilterValues[filter] = values;
        }
        else {
            delete state.currentFilterValues[filter];
        }
    }
};
